import axios from "src/lib/axios";


export const getOrderListBySeller = ({
  keyword = null,
  page = null,
  page_size = null,
  status = "all",
}) => {
  return axios.get(`/orders/seller-list`, {
    params: {
      keyword: keyword,
      page: page,
      page_size: page_size,
      status: status,
      order_case: "desc",
    },
  });
};

export const getOrderDetailBySeller = (id) => axios.get(`/orders/seller/${id}`);
